/* Vintage Hardware & Lighting — Theme JS */

(function () {
  'use strict';

  // ============================================================
  // Mobile sidebar drawer
  // ============================================================
  const sidebar = document.querySelector('.vh-sidebar');
  const toggle = document.querySelector('[data-sidebar-toggle]');
  const backdrop = document.querySelector('[data-sidebar-backdrop]');

  function openSidebar() {
    sidebar && sidebar.classList.add('open');
    backdrop && backdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    sidebar && sidebar.classList.remove('open');
    backdrop && backdrop.classList.remove('open');
    document.body.style.overflow = '';
  }

  toggle && toggle.addEventListener('click', openSidebar);
  backdrop && backdrop.addEventListener('click', closeSidebar);

  // ============================================================
  // Product gallery thumbnail switching
  // ============================================================
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        const src = thumb.dataset.full;
        if (src && main) main.src = src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });

  // ============================================================
  // Product tabs (Description / Measurements / Wattage)
  // ============================================================
  document.querySelectorAll('[data-product-tabs]').forEach(function (group) {
    const tabs = group.querySelectorAll('[data-tab]');
    const panels = group.querySelectorAll('[data-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const id = tab.dataset.tab;
        tabs.forEach((t) => t.classList.toggle('active', t === tab));
        panels.forEach((p) => p.classList.toggle('active', p.dataset.panel === id));
      });
    });
  });

  // ============================================================
  // Sticky add-to-cart bar on product pages
  // ============================================================
  const productBuy = document.querySelector('[data-product-buy]');
  const stickyBar = document.querySelector('[data-sticky-buy]');
  if (productBuy && stickyBar) {
    const onScroll = () => {
      const rect = productBuy.getBoundingClientRect();
      stickyBar.classList.toggle('visible', rect.bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ============================================================
  // Filter accordions on collection pages
  // ============================================================
  document.querySelectorAll('[data-filter-group]').forEach(function (group) {
    const header = group.querySelector('[data-filter-header]');
    header && header.addEventListener('click', () => group.classList.toggle('open'));
  });

  // ============================================================
  // Favorite toggle (localStorage-backed)
  // ============================================================
  const FAV_KEY = 'vh:favorites';
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '{}'); } catch (e) { return {}; }
  }
  function setFavs(f) { localStorage.setItem(FAV_KEY, JSON.stringify(f)); }
  function refreshFavs() {
    const favs = getFavs();
    document.querySelectorAll('[data-fav]').forEach(function (btn) {
      const sku = btn.dataset.fav;
      btn.classList.toggle('active', !!favs[sku]);
      btn.innerHTML = favs[sku] ? '♥' : '♡';
    });
  }
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-fav]');
    if (!btn) return;
    e.preventDefault();
    const sku = btn.dataset.fav;
    const favs = getFavs();
    favs[sku] ? delete favs[sku] : (favs[sku] = true);
    setFavs(favs);
    refreshFavs();
  });
  refreshFavs();

  // ============================================================
  // Quantity stepper
  // ============================================================
  document.querySelectorAll('[data-qty-input]').forEach(function (input) {
    const root = input.closest('[data-qty]');
    if (!root) return;
    const dec = root.querySelector('[data-qty-dec]');
    const inc = root.querySelector('[data-qty-inc]');
    dec && dec.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value) || 1) - 1); });
    inc && inc.addEventListener('click', () => { input.value = (parseInt(input.value) || 1) + 1; });
  });

})();


// ============================================================
// Collection card image carousel (arrows + "X of N")
// ============================================================
document.querySelectorAll('[data-card-gallery]').forEach(function (gallery) {
  var card = gallery.closest('[data-product-card]');
  if (!card) return;
  var pager = card.querySelector('[data-card-pager]');
  if (!pager) return;

  var images;
  try { images = JSON.parse(pager.getAttribute('data-images')); } catch (e) { return; }
  if (!images || images.length < 2) return;

  var img = gallery.querySelector('[data-card-img]');
  var count = pager.querySelector('[data-card-count]');
  var idx = 0;

  function show(n) {
    idx = (n + images.length) % images.length;
    if (img) img.src = images[idx];
    if (count) count.textContent = (idx + 1) + ' of ' + images.length;
  }

  var prev = pager.querySelector('[data-card-prev]');
  var next = pager.querySelector('[data-card-next]');
  if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx - 1); });
  if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx + 1); });
});


// ============================================================
// Custom Search page (/pages/search-catalog or similar)
// Assembles a /search URL with keyword, price range, and
// category tag filters. No-ops on pages without the form.
// ============================================================
(function () {
  var goBtn = document.getElementById('vhgo');
  if (!goBtn) return; // not on the custom search page

  var catMap = {
    lighting: ['cat-lighting-type', 'cat-induction-led', 'cat-architectural', 'cat-glass-shades', 'cat-medallions', 'cat-boat-lights'],
    hardware: ['cat-door', 'cat-window', 'cat-cabinet', 'cat-switch', 'cat-home'],
    antiques: ['cat-other-antiques', 'cat-antique-lights'],
    parts:    ['cat-parts-kits']
  };

  var boxes = document.querySelectorAll('.vh-cat');
  var allBox = document.querySelector('.vh-cat[value="ALL"]');

  boxes.forEach(function (b) {
    b.addEventListener('change', function () {
      if (b.value === 'ALL') {
        if (b.checked) boxes.forEach(function (o) { if (o !== allBox) o.checked = false; });
      } else if (b.checked) {
        if (allBox) allBox.checked = false;
      }
      var anyOther = [].some.call(boxes, function (o) { return o !== allBox && o.checked; });
      if (!anyOther && allBox) allBox.checked = true;
    });
  });

  function runSearch() {
    var q = (document.getElementById('vhq').value || '').trim();
    var min = (document.getElementById('vhmin').value || '').trim();
    var max = (document.getElementById('vhmax').value || '').trim();
    var params = [];
    params.push('q=' + encodeURIComponent(q || '*'));
    params.push('type=product');
    params.push('options[prefix]=last');
    if (min !== '') params.push('filter.v.price.gte=' + encodeURIComponent(min));
    if (max !== '') params.push('filter.v.price.lte=' + encodeURIComponent(max));
    if (!allBox || !allBox.checked) {
      boxes.forEach(function (b) {
        if (b !== allBox && b.checked && catMap[b.value]) {
          catMap[b.value].forEach(function (tag) {
            params.push('filter.p.tag=' + encodeURIComponent(tag));
          });
        }
      });
    }
    window.location.href = '/search?' + params.join('&');
  }

  goBtn.addEventListener('click', runSearch);

  var qInput = document.getElementById('vhq');
  if (qInput) {
    qInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); runSearch(); }
    });
  }
})();